import { useEffect, useState } from 'react';

const isReadyNow = () => typeof document !== 'undefined' && document.readyState === 'complete';

export function useApplicationReady() {
  const [documentReady, setDocumentReady] = useState<boolean>(() => isReadyNow());

  useEffect(() => {
    if (isReadyNow()) return;

    const handleLoad = () => setDocumentReady(true);

    window.addEventListener('load', handleLoad, { once: true });
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return documentReady;
}
